{
  "version": 1,
  "asset_id": "59d36a72-9720-4e0a-ba6a-cb9aa2e7dbae",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/59d36a72-9720-4e0a-ba6a-cb9aa2e7dbae/hiatal-type-3-second-es-1122.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/59d36a72-9720-4e0a-ba6a-cb9aa2e7dbae/hiatal-type-3-second-es-1122.webp",
  "original_filename": "hiatal-type-3-second-es-1122.webp",
  "size": 101650,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:53:38Z"
}
